import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { MatDialogRef } from '@angular/material';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CATEGORIAS } from '../../interfaces/categorias'
import { PublicacionService } from '../../core/publicacion.service';
import { MatSnackBar } from '@angular/material';

@Component({
  selector: 'app-editarpub',
  templateUrl: './editarpub.component.html',
  styleUrls: ['./editarpub.component.css']
})
export class EditarpubComponent implements OnInit {
  categorias = CATEGORIAS;

  formulario: FormGroup;

  cargando = false;

  mensaje: string;
  icono: string;
  clase: string;

  formErrores = {
    'categoria': '',
    'titulo': '',
    'descripcion': '',
    'precio': '',
  }

  mensajeError = false;

  mensajesValidacion = {
    'categoria': {
      'required': 'La categoría es obligatoria,',
    },
    'titulo': {
      'required': 'El titulo es obligatorio.',
      'minlength': 'El título debe tener más de 5 caractéres',
      'maxlength': 'El título debe tener menos de 50 caracteres.',
    },
    'descripcion': {
      'required': 'La descripcion es obligatoria.',
      'minlength': 'La descripcion debe tener más de 5 caractéres',
      'maxlength': 'La descripcion debe tener menos de 300 caracteres.',
    },
    'precio': {
      'required': 'El valor es obligatorio.',
      // 'minlength': 'El valor debe tener más de 3 cifras',
      'maxlength': 'El valor debe tener menos de 7 cifras.',
      'pattern': 'El valor debe ser un número entero positivo.',
    }
  }


  constructor(public snackBar: MatSnackBar, public publicacionService: PublicacionService, public fb: FormBuilder, public thisDialogRef: MatDialogRef<EditarpubComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.formulario = this.fb.group({
      'categoria': ['', [Validators.required]],
      'titulo': ['', [Validators.required, Validators.minLength(5), Validators.maxLength(50)]],
      'descripcion': ['', [Validators.required, Validators.minLength(5), Validators.maxLength(300)]],
      // 'precio': ['', [Validators.required,Validators.minLength(3),Validators.maxLength(6)]],
      // 'precio': ['', [Validators.required,Validators.pattern('.{2,5}')]],
      // 'precio': ['', [Validators.required,Validators.pattern('[0-9].{2,5}')]],
      'precio': ['', [Validators.required, Validators.pattern('^[1-9]+[0-9]*$'), Validators.maxLength(7)]],
    });
    this.formulario.valueChanges.subscribe(data => this.detectarCambios(data));
    this.detectarCambios();
  }

  detectarCambios(data?: any) {
    if (!this.formulario) { return; }
    const form = this.formulario;
    for (const field in this.formErrores) {
      this.formErrores[field] = '';
      const control = form.get(field);
      if (control && control.dirty && !control.valid) {
        const messages = this.mensajesValidacion[field];
        for (const key in control.errors) {
          this.formErrores[field] += messages[key] + ' ';
        }
      }
    }
  }

  get categoria() { return this.formulario.get('categoria') }
  get titulo() { return this.formulario.get('titulo') }
  get descripcion() { return this.formulario.get('descripcion') }
  get precio() { return this.formulario.get('precio') }

  onCloseConfirm(id: string) {
    this.thisDialogRef.close('Confirm');
    this.publicacionService.actualizarPublicacion(id, {
      titulo: this.titulo.value,
      categoria: this.categoria.value,
      descripcion: this.descripcion.value,
      precio: this.precio.value,
    });
    this.snackBar.open('La publicación ha sido editada correctamente.', 'CERRAR', {
      duration: 4000
    });
  }

  onCloseCancel() {
    this.thisDialogRef.close('Cancel');
  }

  // actualizar(id: string) {
  //   this.cargando = true;

  //   setTimeout(() => {
  //     this.mensaje = "Tu publicación ha sido agregada correctamente.";
  //     this.icono = "fa fa-check";
  //     this.clase = "alert alert-success";
  //   }, 1000);

  //   setTimeout(() => {
  //     this.cargando = false
  //     this.mensaje = '';
  //   }, 3000);

  //   this.publicacionService.actualizarPublicacion(id, { 
  //     titulo: this.titulo.value,
  //     categoria: this.categoria.value,
  //     descripcion: this.descripcion.value,
  //     precio: this.precio.value, 
  //   });

  // }


}



// WEBPACK FOOTER //
// ./src/app/publicaciones/editarpub/editarpub.component.ts